import typeToReducer from 'type-to-reducer';
import update from 'immutability-helper';
import { Reducer } from '@reduxjs/toolkit';
import {
  citiesInitialState,
  CitiesInitialStateType,
} from '../store/initialState';
import { parseAxiosError } from '../utils/axiosResponseHelper';
import { PublistaAction } from '../infrastructure/commonTypes';

export const citiesReducer: Reducer<CitiesInitialStateType, PublistaAction> =
  typeToReducer<CitiesInitialStateType, PublistaAction>(
    {
      CITIES_GET: {
        PENDING: (state: CitiesInitialStateType) =>
          update(state, {
            fetching: { $set: true },
          }),
        REJECTED: (state: CitiesInitialStateType, action: any) => {
          const payload = action?.payload;

          return update(state, {
            fetching: { $set: false },
            fetched: { $set: false },
            error: { $set: parseAxiosError(payload) },
          });
        },
        FULFILLED: (state: CitiesInitialStateType, action: any) => {
          const payload = action?.payload;

          return update(state, {
            fetching: { $set: false },
            fetched: { $set: true },
            data: { $set: payload.data },
            error: { $set: null },
          });
        },
      },
    },
    citiesInitialState
  );
